import { z } from "zod";

export const consigneDtoSchema = z.object({
  id: z.number().nullable().optional(),
  innizRef: z.string().nullable().optional(),
  title: z.string(),
  content: z.string(),
  duration: z.string(),
  order: z.number().optional(),
  techniqueId: z.number().nullable().optional(),
  isInniz: z.boolean().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const consignesDtoSchema = z.array(consigneDtoSchema);
